import { Cell, Row } from "react-aria-components";

import useTypedContext from "hooks/useTypedContext";

import { TableContext } from "./Context";

type TableVirtualizedSpacerRowProps = {
  height: number | undefined;
};

/**
 * TanStack virtualizer injects “before” / “after” rows with a single placeholder cell. React Aria
 * Table requires each row’s cell count (including colSpan) to match the header column count.
 */
const TableVirtualizedSpacerRow = ({ height }: TableVirtualizedSpacerRowProps) => {
  const { selectable, visibleColumnIds } = useTypedContext(TableContext);
  const colSpan = (selectable ? 1 : 0) + visibleColumnIds.length;

  return (
    <Row>
      <Cell colSpan={colSpan} style={{ height }} />
    </Row>
  );
};

export default TableVirtualizedSpacerRow;
